import { useEffect, useState } from "react";
import { Cake, PartyPopper, CalendarDays, ArrowUpRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";
import { scrollToId } from "@/lib/site";
import { Reveal, SectionHead } from "./Reveal";

const ITEMS = [
  { id: "cumpleanos", Icon: Cake, img: "/img/mister.jpg" },
  { id: "fiestas", Icon: PartyPopper, img: "/img/halloween.jpg" },
  { id: "reservas", Icon: CalendarDays, img: "/img/local.jpg" },
];

export const Servicios = () => {
  const { t } = useLang();
  const [open, setOpen] = useState("cumpleanos");

  useEffect(() => {
    const h = (e) => setOpen(e.detail);
    window.addEventListener("open-service", h);
    return () => window.removeEventListener("open-service", h);
  }, []);

  const ask = (id) => {
    window.dispatchEvent(new CustomEvent("prefill-service", { detail: id }));
    scrollToId("contacto");
  };

  const current = ITEMS.find((i) => i.id === open) ?? ITEMS[0];

  return (
    <section id="servicios" data-testid="servicios-section" className="bg-tropical-light py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHead id="servicios" eyebrow={t.servicios.eyebrow} title={t.servicios.title} />
        <Reveal delay={0.05}><p className="mt-6 max-w-lg text-jungle/75">{t.servicios.intro}</p></Reveal>
        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <Reveal className="lg:col-span-7">
            <Accordion type="single" collapsible value={open} onValueChange={(v) => v && setOpen(v)} data-testid="servicios-accordion">
              {ITEMS.map(({ id, Icon }, i) => (
                <AccordionItem key={id} value={id} className="border-b border-jungle/20">
                  <AccordionTrigger data-testid={`servicio-trigger-${id}`} className="py-7 hover:no-underline group">
                    <span className="flex items-center gap-5 text-left">
                      <span className="font-mono-ed text-sm text-jungle/60">0{i + 1}</span>
                      <Icon size={26} className="text-mango" />
                      <span className="font-display text-3xl sm:text-4xl group-hover:text-mango transition-colors">{t.services[id]}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent data-testid={`servicio-content-${id}`}>
                    <div className="pl-0 sm:pl-[4.5rem] pb-4">
                      <img src={ITEMS[i].img} alt={t.services[id]} className="lg:hidden mb-5 w-full aspect-[16/10] object-cover rounded-2xl" />
                      <p className="text-base sm:text-lg text-jungle/80 max-w-lg leading-relaxed">{t.servicios.items[id]}</p>
                      <button data-testid={`servicio-ask-${id}`} onClick={() => ask(id)} className="mt-5 inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-mango hover:gap-3 transition-[gap]">
                        {t.servicios.buttons[id]} <ArrowUpRight size={15} />
                      </button>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
          <Reveal className="hidden lg:block lg:col-span-5" delay={0.15}>
            <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] rounded-tr-[8rem] border-[6px] border-jungle">
              {ITEMS.map((it) => (
                <img key={it.id} src={it.img} alt={t.services[it.id]} className={`absolute inset-0 h-full w-full object-cover transition-[opacity,transform] duration-700 ${it.id === current.id ? "opacity-100 scale-100" : "opacity-0 scale-110"}`} />
              ))}
              <span className="absolute bottom-5 left-5 rounded-full bg-paper/90 backdrop-blur px-4 py-2 font-display text-lg">{t.services[current.id]}</span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
